import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-one-page-callout',
    templateUrl: './wallet-pass-share.component.html',
    styleUrls: ['./wallet-pass-share.component.scss'],
    standalone: false
})

export class WalletPassShareComponent extends BlockAbstractComponent implements OnInit {

    parseURL(url: string): string {
        const baseURL = 'https://onepage.builtoncore.com/api/1.0/download';
        return url.replace('/file/', `${baseURL}/`);
    }
}
